(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hall-commitment"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(slider) {
    if (slider.dataset.hallInit) return;
    slider.dataset.hallInit = '1';
    var track = slider.querySelector('.hall-slider__track');
    var slides = slider.querySelectorAll('.hall-slider__slide');
    var dotsWrap = slider.querySelector('.hall-slider__dots');
    if (!track || !dotsWrap || slides.length < 2) return;
    dotsWrap.innerHTML = '';
    var dots = [];
    Array.prototype.forEach.call(slides, function (slide, i) {
      var b = document.createElement('button');
      b.className = 'hall-slider__dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
      dots.push(b);
    });
    var raf;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        idx = Math.max(0, Math.min(dots.length - 1, idx));
        dots.forEach(function (d, i) {
          if (i === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      });
    }, { passive: true });
  }
  function initAll(root) {
    (root || document).querySelectorAll('.hall-slider').forEach(initSlider);
  }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
